
export default function (state = [], action) {
    if (action.type === 'RUNDE_ACTIVE') {
        if (action.payload.type === 'multy') {
            var index = state.indexOf(action.payload.round);
            if (index > -1) {
                state = [
                    ...state.slice(0, index),
                    ...state.slice(index + 1)
                ];
            } else {
                state = state.concat(action.payload.round);
            }
        }
        else if (action.payload.type === 'unique') {
            state = [action.payload.round]
        }
    }
    return state;
}
